import React, {
  useState,
  useEffect
} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link as RouterLink,
} from "react-router-dom";

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Breadcrumbs,
  Link,
  Grid,
  Typography,
  Button,
  IconButton,
  Divider,
  Collapse,
  ListSubheader,
} from '@material-ui/core';
import {
  Skeleton
} from '@material-ui/lab';
import Alert from '@material-ui/lab/Alert';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

import localization from '../utils/localizations';
import {
  IssueReportPanel,
  ThesisDetail,
  ThesisConsultations,
  StatusTimeline,
  ThesisWritingForm,
  DateTimeView,
  FileCommentsHistory,
  ThesisSharedDocuments,
  AdminNotes,
} from '../views';

import { useStatus } from '../data/Status';
import filterDocumentBy from '../utils/filterDocumentBy';
import grabAllDocuments from '../utils/grabAllDocuments';
import {
  Document
} from '../types';

const appConfig = (window as any).APP_CONFIG;


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  secondPanel: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  pageTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
  breadcrumbs: {
    margin: 10,
  },
  mainGrid: {
    marginTop: 20,
  },
  gridLabel: {
    textAlign: 'right',
    color: '#555555',
  },
  alignRight: {
    textAlign: 'right',
  },
  ugbOpenMessage: {
    marginTop: 10,
    marginBottom: 10,
  }
}));


function ThesisWritingPage() {
  const classes = useStyles();

  const [status, statusLoading, loadStatus] = useStatus();
  const [showForm, setShowForm] = useState(false);
  let allDocuments: Document[] = [];

  let currentData = undefined;

  if (status?.thesis?.id) {
    currentData = {
      title: status.thesis.title,
      thesis_docx: filterDocumentBy(status.thesis.documents, {kind: 'Thesis', content_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"}),
      thesis_pdf: filterDocumentBy(status.thesis.documents, {kind: 'Thesis', content_type: "application/pdf"}),
    }
    allDocuments = grabAllDocuments(status.thesis.documents, status.thesis.status_history);
  }

  let disableEdit = !(status?.thesis);
  let submissionDeadlineReached = false;
  let deadline = status?.current_ugb_period?.thesis_writing_end;
  if (deadline) {
    if (moment() > moment(deadline)) {
      disableEdit = true;
      submissionDeadlineReached = true;
    }
  }

  if (!deadline) {
    disableEdit = true;
  }

  return (
    <>
    <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumbs}>
      <Link color="inherit" to={`${appConfig.homepage}`} component={RouterLink}>
        {localization.home}
      </Link>
      <Typography color="textPrimary">{localization.thesis}</Typography>
    </Breadcrumbs>

    <Paper className={classes.mainBody}>
      <ListSubheader style={{paddingLeft: 8}}>{localization.thesisPageTitle}</ListSubheader>

      <Collapse
        in={!showForm}
      >
        {!status.success ? (
          <div style={{position: 'relative', padding: 10}}>
            <Skeleton variant="rect" width={'100%'} height={20} style={{marginBottom: 10}}/>
            <Skeleton variant="rect" width={'100%'} height={20} style={{marginBottom: 40}}/>
            <Skeleton variant="rect" width={'30%'} height={20} style={{display: 'inline-block', marginBottom: 20, marginRight: 20}}/>
            <Skeleton variant="rect" width={'60%'} height={20} style={{display: 'inline-block', marginBottom: 20}}/>
            <Skeleton variant="rect" width={'30%'} height={20} style={{display: 'inline-block', marginBottom: 20, marginRight: 20}}/>
            <Skeleton variant="rect" width={'60%'} height={20} style={{display: 'inline-block', marginBottom: 20}}/>
            <Skeleton variant="rect" width={'30%'} height={20} style={{display: 'inline-block', marginBottom: 20, marginRight: 20}}/>
            <Skeleton variant="rect" width={'60%'} height={20} style={{display: 'inline-block', marginBottom: 20}}/>
          </div>
        ) : (
          submissionDeadlineReached ?
          (<Alert
            severity="error"
            className={classes.ugbOpenMessage}
          >
            {localization.submissionHasBeenClosedOn} <DateTimeView value={deadline} format={"Do MMMM YYYY HH:mm:ss"} /> (<DateTimeView value={deadline} fromNow />)
          </Alert>)
          :
          (<>

          {!!deadline ? <Alert
            severity="info"
            className={classes.ugbOpenMessage}
          >
            {localization.thesisSubmissionOpenUntil} <DateTimeView value={deadline} format={"Do MMMM YYYY HH:mm:ss"} /> (<DateTimeView value={deadline} fromNow />)
          </Alert>:
          <Alert
            severity="info"
            className={classes.ugbOpenMessage}
          >
            {localization.thesisSubmissionNotOpen}
          </Alert>}
          </>)
        )}

        {status && status.thesis && status.thesis.status &&
          <ThesisDetail thesis={status.thesis} />
        }

        <Grid container spacing={3}>
          <Grid item xs={6}>
            {/* <Button
              variant="contained"
              color="primary"
              startIcon={<EditIcon/>}
              onClick={(e: any) => {
                setShowForm(true);
              }}
              disabled={disableEdit}
            >{localization.uploadLatestThesisFiles}</Button> */}
          </Grid>
          <Grid item xs={6} className={classes.alignRight}>
            <Button
              variant="contained"
              to={`${appConfig.homepage}`} component={RouterLink}
            >{localization.backToHome}</Button>
          </Grid>
        </Grid>
      </Collapse>

      {/* <Collapse
        in={showForm}
        {...(showForm ? { timeout: 1000 } : {})}
      >
        <ThesisWritingForm
          onSubmitted={() => {
            setShowForm(false);
            loadStatus();
          }}
          onCancelled={() => {
            setShowForm(false);
          }}
          values={currentData}
        />
      </Collapse> */}
    </Paper>

    {status && status.thesis && 
      <ThesisSharedDocuments thesisId={status.thesis.id} hideIfEmpty /> }

    {status && status.thesis && 
      <ThesisConsultations
        thesis={status.thesis}
        onAdded={() => {
          loadStatus();
        }}
        readOnly={disableEdit}
      /> }
    
    {(status?.thesis?.notes?.length > 0) &&
      <AdminNotes notes={status.thesis.notes} />
    }

    {status && status.thesis && (allDocuments.length > 0) && <FileCommentsHistory documents={allDocuments} /> }

    {status && status.thesis && <StatusTimeline history={status.thesis.status_history} collapsed={true} hideIfEmpty={true}/> }

    <IssueReportPanel />
    </>
  );
}

export default ThesisWritingPage;